//TODAY_PRODUCTIVITY_LIST
export const USER_ID_PRODUCTIVITY_REQUEST = "USER_ID_PRODUCTIVITY_REQUEST";
export const USER_ID_PRODUCTIVITY_SUCCESS = "USER_ID_PRODUCTIVITY_SUCCESS";
export const USER_ID_PRODUCTIVITY_FAIL = "USER_ID_PRODUCTIVITY_FAIL";

//MONTH_PRODUCTIVITY_LIST
export const USER_MONTH_PRODUCTIVITY_REQUEST =
  "USER_MONTH_PRODUCTIVITY_REQUEST";
export const USER_MONTH_PRODUCTIVITY_SUCCESS =
  "USER_MONTH_PRODUCTIVITY_SUCCESS";
export const USER_MONTH_PRODUCTIVITY_FAIL = "USER_MONTH_PRODUCTIVITY_FAIL";

//TODAY_ALL_PRODUCTIVITY_LIST
export const USER_TODAY_ALL_PRODUCTIVITY_REQUEST =
  "USER_TODAY_ALL_PRODUCTIVITY_REQUEST";
export const USER_TODAY_ALL_PRODUCTIVITY_SUCCESS =
  "USER_TODAY_ALL_PRODUCTIVITY_SUCCESS";
export const USER_TODAY_ALL_PRODUCTIVITY_FAIL =
  "USER_TODAY_ALL_PRODUCTIVITY_FAIL";

//TODAY_ALL_FOR_REPORT_PRODUCTIVITY_LIST
export const USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_REQUEST =
  "USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_REQUEST";
export const USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_SUCCESS =
  "USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_SUCCESS";
export const USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_FAIL =
  "USER_TODAY_ALL_FOR_REPORT_PRODUCTIVITY_FAIL";

//MONTH_ALL_PRODUCTIVITY_LIST
export const USER_MONTH_ALL_PRODUCTIVITY_REQUEST =
  "USER_MONTH_ALL_PRODUCTIVITY_REQUEST";
export const USER_MONTH_ALL_PRODUCTIVITY_SUCCESS =
  "USER_MONTH_ALL_PRODUCTIVITY_SUCCESS";
export const USER_MONTH_ALL_PRODUCTIVITY_FAIL =
  "USER_MONTH_ALL_PRODUCTIVITY_FAIL";

//PREV_PRODUCTIVITY_LIST
export const USER_PREV_PRODUCTIVITY_REQUEST = "USER_PREV_PRODUCTIVITY_REQUEST";
export const USER_PREV_PRODUCTIVITY_SUCCESS = "USER_PREV_PRODUCTIVITY_SUCCESS";
export const USER_PREV_PRODUCTIVITY_FAIL = "USER_PREV_PRODUCTIVITY_FAIL";
